import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const notifications = [{
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'David Smith',
  initials: 'DS',
  time: '12 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Emily Chen',
  initials: 'EC',
  time: '18 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'Michael Brown',
  initials: 'MB',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Jessica Walsh',
  initials: 'JW',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" aria-live="polite" data-id="element-282" data-mp="ylr0jwvh4nhs">
      <AnimatePresence mode="wait" data-id="element-283" data-mp="3j8ubck8hwbx0">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-carbon-graphite border border-gold/40 rounded-xl p-3.5 shadow-[0_10px_30px_-12px_rgba(0,0,0,0.8)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-284" data-mp="3kr2g43tu64u0">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-smoke hover:text-white transition-colors" aria-label="Close notification" data-id="element-285" data-mp="31ygl1lqr6iah">
              <XIcon size={14} data-id="element-286" data-mp="2x1zxotrdo7yg" />
            </button>
            <div className="flex items-center gap-3" data-id="element-287" data-mp="2j1fcjqxzq01s">
              <div className="relative shrink-0" data-id="element-288" data-mp="2j1yyrjuobalm">
                <div className="w-11 h-11 rounded-full border border-gold flex items-center justify-center text-gold font-bold text-sm" data-id="element-289" data-mp="2n2skc6kn8dbc">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-carbon-graphite shadow" data-id="element-290" data-mp="1zfx1w3bxc7ye" />
              </div>
              <div className="flex-1 min-w-0 pr-4" data-id="element-291" data-mp="2nd2udy4t0322">
                <div className="flex items-center gap-1.5 text-[11px] text-smoke mb-0.5" data-id="element-292" data-mp="2nbhx40r3u60i">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-293" data-mp="2ie9drwu7zvxo" />
                  <span className="truncate" data-id="element-294" data-mp="2s6fd5rmsxfmw">{current.location}</span>
                </div>
                <p className="text-white text-[13px] leading-snug" data-id="element-295" data-mp="364diy8n243qs">
                  <span className="font-bold" data-id="element-296" data-mp="316293xwrht8k">{current.name}</span>{' '}
                  <span className="text-mist" data-id="element-297" data-mp="3l7n9ynscozrl">
                    purchased BJJ Coach Ready
                  </span>
                </p>
                <div className="flex items-center gap-1.5 text-[10px] text-gold font-medium mt-1" data-id="element-298" data-mp="3p7e513owu21x">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-299" data-mp="3tzyyu57tgf5g" />
                  <ShoppingBagIcon size={10} data-id="element-300" data-mp="2tdzly7ly0xc" />
                  <span data-id="element-301" data-mp="2v8mvj6cq54l">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}